import { render, staticRenderFns } from "./ReferHoverTip.vue?vue&type=template&id=460003d4&scoped=true"
import script from "./ReferHoverTip.vue?vue&type=script&lang=js"
export * from "./ReferHoverTip.vue?vue&type=script&lang=js"
import style0 from "./ReferHoverTip.vue?vue&type=style&index=0&id=460003d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460003d4",
  null
  
)

export default component.exports